import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'

function isNewRelevanceAlgoEnabledbyExperiment(experiment: string) {
  const experiments = useExperiments()

  const isNewRelevanceAlgoEnabled =
    experiments[`experiment.${experiment}`] === 'relevanceV2'

  const orderBy: '-relevance' | '-relevance_alt' = isNewRelevanceAlgoEnabled
    ? '-relevance_alt'
    : '-relevance'

  return {
    orderBy,
    isNewRelevanceAlgoEnabled,
  }
}

export function useRelevanceAlgo() {
  return isNewRelevanceAlgoEnabledbyExperiment('reviewRelevanceAlgorithm')
}

export function useRelevanceAlgoPPGallery() {
  return isNewRelevanceAlgoEnabledbyExperiment(
    'reviewRelevanceAlgorithmPPGallery',
  )
}
